(function(){
  'use strict';

  if (window.__VSKLO_BOXES_PAGE_V1__) return;
  window.__VSKLO_BOXES_PAGE_V1__ = true;

  function initBoxes(root){
    if(!root || root.dataset.vskloBoxesInitialized === 'true') return;
    root.dataset.vskloBoxesInitialized = 'true';

    // Global floating-contact delegate owns box CTAs. A second local click
    // handler opened the widget twice or unexpectedly launched tel: fallback.

    var slider = root.querySelector('[data-vb-slider]');
    if(slider){
      var slides = slider.querySelectorAll('.vb-slide');
      var dots = slider.querySelectorAll('.vb-dot');
      var thumbs = slider.querySelectorAll('.vb-thumb');
      var current = 0;
      var interval = parseInt(slider.getAttribute('data-vb-interval'),10) || 2300;
      var timer = null;

      function setSlide(next){
        if(!slides.length) return;
        slides[current].classList.remove('is-active');
        if(dots[current]) dots[current].classList.remove('is-active');
        if(thumbs[current]) thumbs[current].classList.remove('is-active');
        current = (next + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if(dots[current]) dots[current].classList.add('is-active');
        if(thumbs[current]) thumbs[current].classList.add('is-active');
      }

      function start(){
        if(slides.length > 1 && !timer){
          timer = window.setInterval(function(){ setSlide(current + 1); },interval);
        }
      }

      function stop(){
        if(timer){
          window.clearInterval(timer);
          timer = null;
        }
      }

      function restart(){
        stop();
        start();
      }

      dots.forEach(function(dot){
        dot.addEventListener('click',function(){
          setSlide(parseInt(dot.getAttribute('data-vb-to'),10) || 0);
          restart();
        });
      });

      thumbs.forEach(function(thumb){
        thumb.addEventListener('click',function(){
          setSlide(parseInt(thumb.getAttribute('data-vb-to'),10) || 0);
          restart();
        });
      });

      slider.addEventListener('mouseenter',stop);
      slider.addEventListener('mouseleave',start);
      slider.addEventListener('focusin',stop);
      slider.addEventListener('focusout',start);
      start();
    }

    var widthInput = root.querySelector('#vbBoxWidth');
    var heightInput = root.querySelector('#vbBoxHeight');
    var depthInput = root.querySelector('#vbBoxDepth');
    var qtyInput = root.querySelector('#vbBoxQty');
    var plywoodInput = root.querySelector('#vbBoxPlywood');
    var lidInput = root.querySelector('#vbBoxLid');
    var priceEl = root.querySelector('#vbCalcPrice');
    var unitEl = root.querySelector('#vbCalcUnit');
    var sizeEl = root.querySelector('#vbCalcSize');
    var materialEl = root.querySelector('#vbCalcMaterial');
    var discountEl = root.querySelector('#vbCalcDiscount');

    function clampNumber(value,min,fallback){
      var number = parseFloat(value);
      if(!isFinite(number)) number = fallback;
      return Math.max(min,number);
    }

    function localeUi(){
      var lang = String(document.documentElement.lang || (window.Shopify && Shopify.locale) || 'uk').toLowerCase();
      if(lang.indexOf('de') === 0) return {intl:'de-DE',from:'ab ',to:' bis ',per:' / Stk.',mm:' mm',plywood4:'4 mm Sperrholz',plywood6:'6 mm Sperrholz'};
      if(lang.indexOf('pl') === 0) return {intl:'pl-PL',from:'od ',to:' do ',per:' / szt.',mm:' mm',plywood4:'Sklejka 4 mm',plywood6:'Sklejka 6 mm'};
      if(lang.indexOf('en') === 0) return {intl:'en-US',from:'from ',to:' to ',per:' / pc',mm:' mm',plywood4:'4 mm plywood',plywood6:'6 mm plywood'};
      return {intl:'uk-UA',from:'від ',to:' до ',per:' / шт',mm:' мм',plywood4:'Фанера 4 мм',plywood6:'Фанера 6 мм'};
    }

    function presentmentCurrency(){
      return String(
        (window.VSKLO_STOREFRONT && window.VSKLO_STOREFRONT.currency) ||
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
        window.vskloPresentmentCurrency || ''
      ).toUpperCase();
    }

    function presentmentRate(){
      var rate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      return Number.isFinite(rate) && rate > 0 ? rate : 1;
    }

    function formatUAH(value){
      var ui = localeUi();
      var currency = presentmentCurrency();
      var converted = Math.round(Number(value || 0) * presentmentRate());
      try {
        return new Intl.NumberFormat(ui.intl, {style:'currency', currency:currency, maximumFractionDigits:0}).format(converted);
      } catch (error) {
        return converted.toLocaleString(ui.intl) + ' ' + currency;
      }
    }

    function calculateBox(){
      if(!widthInput || !heightInput || !depthInput || !qtyInput || !plywoodInput || !lidInput || !priceEl || !unitEl || !sizeEl || !materialEl) return;

      var w = clampNumber(widthInput.value,60,300);
      var h = clampNumber(heightInput.value,30,100);
      var d = clampNumber(depthInput.value,60,200);
      var qty = Math.round(clampNumber(qtyInput.value,1,1));
      var areaM2 = (2 * (w*d + w*h + d*h)) / 1000000;
      var perimeterM = (4 * (w+d+h)) / 1000;
      var volumeFactor = Math.max(1,(w*h*d) / 6000000);
      var materialRate = volumeFactor > 3.2 ? 760 : 560;
      var cutRate = 34;
      var assembly = 115;
      var base = 95;
      var lidMultiplier = {simple:1,sliding:1.18,hinged:1.32,premium:1.48}[lidInput.value] || 1;
      var plywoodMultiplier = plywoodInput.value === '6' ? 1.10 : 1;
      var overallPriceMultiplier = 0.90;
      var unit = (base + areaM2 * materialRate + perimeterM * cutRate + assembly) * lidMultiplier * plywoodMultiplier * overallPriceMultiplier;
      var discountRate = 0;

      if(qty >= 10) discountRate = 0.05;
      if(qty >= 30) discountRate = 0.10;
      if(qty >= 50) discountRate = 0.15;
      if(qty >= 100) discountRate = 0.22;
      if(qty >= 200) discountRate = 0.30;

      unit = unit * (1-discountRate);
      var minTotal = unit * qty * 0.9;
      var maxTotal = unit * qty * 1.18;

      var ui = localeUi();
      priceEl.textContent = ui.from + formatUAH(minTotal) + ui.to + formatUAH(maxTotal);
      unitEl.textContent = formatUAH(unit) + ui.per;
      sizeEl.textContent = Math.round(w) + ' × ' + Math.round(h) + ' × ' + Math.round(d) + ui.mm;
      materialEl.textContent = plywoodInput.value === '6' ? ui.plywood6 : ui.plywood4;
      if(discountEl) discountEl.textContent = Math.round(discountRate * 100) + '%';
    }

    [widthInput,heightInput,depthInput,qtyInput,plywoodInput,lidInput].forEach(function(input){
      if(!input) return;
      input.addEventListener('input',calculateBox);
      input.addEventListener('change',calculateBox);
    });
    calculateBox();
  }

  function initAll(scope){
    var context = scope || document;
    if(context.matches && context.matches('#vsklo-boxes-premium')) initBoxes(context);
    if(context.querySelectorAll){
      context.querySelectorAll('#vsklo-boxes-premium').forEach(initBoxes);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',function(){ initAll(document); });
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',function(event){
    initAll(event.target);
  });
})();
